module.exports = __webpack_public_path__ + "img/equalizer-placeholder2.55494f31.jpg";